import { AbstractBlock } from '../AbstractBlock';
import { ColorSettings } from '../setting/ColorSettings';
import { ShapeSettings } from '../setting/ShapeSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();
const t = block_translation;

export class ARGpsCameraOnAttribute extends AbstractBlock {
  constructor() {
    super('ar-gps-camera-on', t.to('GPS ARカメラ', 'gps_ar_camera'));
  }
  defineBlock(block: BlockType): void {
    ShapeSettings.setAttributeShape(block);
    ColorSettings.setARColor(block);

    const latitude = new Blockly.FieldTextInput('');
    const longitude = new Blockly.FieldTextInput('');

    ShapeSettings.setTitleField(block, this.title);

    block
      .appendDummyInput()
      .appendField(t.to('カメラ緯度', 'cam_longitude'))
      .appendField(longitude, 'longitude')
      .appendField(t.to('カメラ経度', 'cam_latitude'))
      .appendField(latitude, 'latitude');

    ShapeSettings.addAttributeInput(block);
  }

  codeGenerateCore(block: BlockType): string[] {
    const longitude = CodeSetting.getFieldValue(block, 'longitude');
    const latitude = CodeSetting.getFieldValue(block, 'latitude');
    const attribute = CodeSetting.getSubAttributeCode(block);

    let simulate = '';
    if (latitude === '' && longitude === '') {
      simulate = `SimulateLatitude: ${longitude}; SimulateLongitude: ${latitude}`;
    }

    const str = CodeSetting.getAttributeCode('gps-camera', simulate) + attribute;
    return [str];
  }
}
